import React, { useState, useEffect, useContext } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Menu, Button, Row, Drawer } from 'antd';
import { CustomerAccountType, CustomerLocationType, KEY_SIDE_NAV, LANGUAGE } from 'common';
import styles from './styles.module.scss';
import avatarImg from 'assets/images/avatar.svg';
import iconNext from 'assets/images/next.svg';
import iconDashboard from 'assets/images/dashboard.svg';
import iconTurnLeft from 'assets/images/turnLeft.svg';
import iconTurnRight from 'assets/images/turnRight.svg';
import iconChecklist from 'assets/images/checklist.svg';
import iconWarehouse from 'assets/images/warehouse.svg';
import iconInvestment from 'assets/images/investment.svg';
import iconPackage from 'assets/images/package.svg';
import iconMedicalReport from 'assets/images/medical-report.svg';
import avatarDefault from 'assets/images/account.png';
import { useTranslation } from 'react-i18next';
import { IsTourOpenContext } from 'components/WrapperContext/IsTourOpenProvider';
import { IsMobileContext } from 'components/WrapperContext/IsMobileProvider';
import classNames from 'classnames';
import _ from 'lodash';
import configs from 'config';
import TourMenu from './TourMenu';
import { useQuery, useQueryClient } from 'react-query';
import { getFullNameByLocation } from 'utils';

const { SubMenu } = Menu;
const defaultOpenSelectedKey = JSON.parse((localStorage.getItem('selectedKey') as any) || '1');
const defaultOpenKeys = JSON.parse((localStorage.getItem('sidenav_open_menu') as string) || '[]');
export default function SideNav() {
  // const [isTourOpen, setIsTourOpen] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const queryClient = useQueryClient();
  const [openKeys, setOpenKeys] = useState(defaultOpenKeys);
  const { isTourOpen, setIsTourOpen } = useContext(IsTourOpenContext);
  const { data: profile } = queryClient?.getQueryData('profile') as any;
  // queryClient.refetchQueries('profile')
  // queryClient.invalidateQueries('profile')
  const { isMobile, isOpenMenuMobile, setIsOpenMenuMobile } = useContext(IsMobileContext);
  const { t, i18n } = useTranslation();

  // const subMenuShipping = [
  //   {
  //     key: KEY_SIDE_NAV.SHIPPING_2,
  //     text: t('sideNav.shipping'),
  //     keyTour: 'reactour__shipping_2',
  //     url: '/table/order/shipping',
  //   },
  //   {
  //     key: KEY_SIDE_NAV.SHIPPING_SHIPPING_FROM_HOME,
  //     text: t('sideNav.pickupFromYourAddress'),
  //     keyTour: 'reactour__pickupFromYourAddress',
  //     url: '/table/order/shipping-from-address',
  //   },
  // ];
  const [collapsed, setCollapsed] = useState(false);
  const toggleCollapsed = () => setCollapsed(!collapsed);
  const [selectedKey, setSelectedKey] = useState(defaultOpenSelectedKey);
  const accountType: any = {
    [CustomerAccountType.BUSINESS]: t('accountType.business'),
    [CustomerAccountType.PERSONAL]: t('accountType.personal'),
  };
  const textChangeOrDeleteAccount: any = {
    [CustomerAccountType.PERSONAL]: t('sideNav.changeAccount'),
    [CustomerAccountType.BUSINESS]: t('sideNav.deleteAccount'),
  };
  const routes = [
    {
      key: KEY_SIDE_NAV.DASHBOARD,
      text: t('sideNav.dashboard'),
      url: '/dashboard',
      keyTour: 'reactour__dashboard',
      icon: <img src={iconDashboard} />,
    },
    {
      key: KEY_SIDE_NAV.ORDER,
      text: t('sideNav.myOrder'),
      icon: <img src={iconChecklist} />,
      keyTour: 'reactour__myOrder',
      children: [
        {
          key: KEY_SIDE_NAV.SHIPPING_2,
          text: t('sideNav.shipping'),
          keyTour: 'reactour__shipping',
          url: '/table/order/shipping',
          visible: true,
        },
        {
          key: KEY_SIDE_NAV.SHIPPING_SHIPPING_FROM_HOME,
          text: t('sideNav.pickupFromYourAddress'),
          keyTour: 'reactour__pickupFromYourAddress',
          url: '/table/order/shipping-from-address',
          visible: true,
        },
        // {
        //   key: KEY_SIDE_NAV.SHIPPING,
        //   text: t('sideNav.shipping'),
        //   url: '/table/order/shipping',
        //   keyTour: 'reactour__shipping',
        //   children:
        //     profile?.accountType === CustomerAccountType.BUSINESS &&
        //       profile?.locationType === CustomerLocationType.DOMESTIC
        //       ? subMenuShipping
        //       : '',
        // },
        {
          key: KEY_SIDE_NAV.SHOPPING,
          text: t('sideNav.shopping'),
          keyTour: 'reactour__shopping',
          url: '/table/order/shopping',
          visible: profile?.locationType === CustomerLocationType.FOREIGN,
        },
        {
          key: KEY_SIDE_NAV.CUSTOMS_DUTY,
          text: t('sideNav.customsDuty'),
          url: '/table/order/customs-duty',
          visible: true,
        },
      ],
    },
    {
      key: KEY_SIDE_NAV.WAREHOUSE,
      text: t('sideNav.myWarehouse'),
      url: '/my-ware-house',
      keyTour: 'reactour__myWarehouse',
      icon: <img src={iconWarehouse} />,
    },
    {
      key: KEY_SIDE_NAV.PAYMENT_HISTORY,
      text: t('sideNav.paymentHistory'),
      url: '/list-payment-history',
      keyTour: 'reactour__paymentHistory',
      icon: <img src={iconInvestment} />,
    },
    {
      key: KEY_SIDE_NAV.PACKAGE,
      text: t('sideNav.listPackage'),
      url: '/list-package',
      keyTour: 'reactour__package',
      icon: <img src={iconPackage} width={15} />,
    },
    // {
    //   key: KEY_SIDE_NAV.REPORTS,
    //   text: t('sideNav.reports'),
    //   url: '/reports',
    //   keyTour: 'reactour__reports',
    //   icon: <img src={iconMedicalReport} />,
    // },
  ] as any;
  const rootSubmenuKeys = [KEY_SIDE_NAV.MY_PROFILE, KEY_SIDE_NAV.ORDER];
  useEffect(() => {
    if (profile?.isVisibilityIntro || isTourOpen) {
      const dataOpenMenu = [KEY_SIDE_NAV.MY_PROFILE, KEY_SIDE_NAV.ORDER, KEY_SIDE_NAV.SHIPPING];
      setOpenKeys(dataOpenMenu);
      setIsTourOpen(true);
    }
  }, [profile, isTourOpen]);
  useEffect(() => {
    routes.forEach((route: any) => {
      if (location.pathname.startsWith(route.url || '###')) {
        localStorage.setItem('selectedKey', JSON.stringify(route.key));
        setSelectedKey(route.key);
      }
      if (route.children) {
        route.children.forEach((childRoute: any) => {
          if (location.pathname.startsWith(childRoute.url || '###')) {
            setSelectedKey(childRoute.key);
            localStorage.setItem('selectedKey', JSON.stringify(childRoute.key));

            if (childRoute?.children) {
              childRoute?.children?.forEach((childRoute: any) => {
                if (location.pathname.startsWith(childRoute.url || '###')) {
                  setSelectedKey(childRoute.key);
                  localStorage.setItem('selectedKey', JSON.stringify(childRoute.key));
                }
              });
            }
          }
        });
      }
    });
  }, [location.pathname]);

  const onClose = () => {
    setIsOpenMenuMobile(false);
  };
  const handleOpenChange = (keys: any) => {
    const latestOpenKey = keys.find((key: any) => openKeys.indexOf(key) === -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
      localStorage.setItem('sidenav_open_menu', JSON.stringify(keys));
    } else {
      const keyMenu = latestOpenKey ? [latestOpenKey] : [];
      setOpenKeys(keyMenu);
      localStorage.setItem('sidenav_open_menu', JSON.stringify(keyMenu));
    }
  };
  return (
    <>
      {!isMobile ? (
        <div
          className={classNames(styles.sideNav, {
            ['pointerNone']: isTourOpen,
          })}
        >
          <>
            <div
              className={classNames('centerElement', styles.avatarSideNav, {
                [styles.avatarSideNav35]: collapsed,
              })}
            >
              <img
                src={profile?.avatar || avatarDefault}
                onClick={() => history.push('/my-page/personal-information')}
              />
            </div>
            {!collapsed && (
              <div className={styles.textContainer}>
                <div className={classNames('centerElement', styles.textWrapper)}>{getFullNameByLocation(profile)}</div>
                <div className={classNames('centerElement', styles.textWrapper)}>
                  {accountType[profile?.accountType]}
                </div>
              </div>
            )}
          </>
          <Menu
            selectedKeys={[selectedKey]}
            openKeys={openKeys}
            onOpenChange={handleOpenChange}
            mode="inline"
            inlineCollapsed={collapsed}
            className="menuWrapperSideNav"
            style={{ width: collapsed ? 80 : 215, transition: 'width 0.3s', marginBottom: 20 }}
          >
            {routes?.map((route: any) => {
              if (route?.children) {
                return (
                  <SubMenu key={route.key} icon={route.icon} title={route.text} data-tut={route?.keyTour}>
                    {route?.children?.map((childRoute: any) => {
                      if (!childRoute?.visible) return;
                      if (
                        childRoute.key === KEY_SIDE_NAV.SHIPPING_SHIPPING_FROM_HOME &&
                        profile?.accountType === CustomerAccountType.BUSINESS &&
                        profile?.locationType === CustomerLocationType.DOMESTIC
                      ) {
                        return (
                          <Menu.Item key={childRoute.key} data-tut={childRoute?.keyTour}>
                            <Link to={childRoute.url}>{childRoute.text}</Link>
                          </Menu.Item>
                        );
                      }
                      if (childRoute.key !== KEY_SIDE_NAV.SHIPPING_SHIPPING_FROM_HOME) {
                        return (
                          <Menu.Item key={childRoute.key} data-tut={childRoute?.keyTour}>
                            <Link to={childRoute.url}>{childRoute.text}</Link>
                          </Menu.Item>
                        );
                      }
                    })}
                  </SubMenu>
                );
              }
              return (
                <Menu.Item key={route.key} icon={route.icon} data-tut={route?.keyTour}>
                  <Link to={route.url}>{route.text}</Link>
                </Menu.Item>
              );
            })}
          </Menu>
          <Row
            data-tut="reactour__toggleCollapsed"
            justify="start"
            className={classNames(styles.collapseWrapper, {
              ['centerElement']: collapsed,
            })}
            style={{ width: collapsed ? 80 : 215 }}
          >
            <div onClick={toggleCollapsed} className={styles.collapseButton}>
              {collapsed ? (
                <div>
                  <img src={iconTurnRight} />
                </div>
              ) : (
                <div>
                  <img src={iconTurnLeft} />
                  {t('sideNav.collapsedText')}
                </div>
              )}
            </div>
          </Row>
        </div>
      ) : (
        ''
      )}
      <Drawer
        placement="left"
        closable={false}
        onClose={onClose}
        visible={isOpenMenuMobile}
        className={styles.menuMobile}
        headerStyle={{ display: 'none' }}
      >
        <div
          className={classNames('centerElement', styles.avatarSideNav, {
            [styles.avatarSideNav35]: collapsed,
          })}
        >
          <img src={profile?.avatar || avatarDefault} />
        </div>
        <div className={styles.textContainer}>
          <div className={classNames('centerElement', styles.textWrapper)}>{profile.fullName}</div>
          <div className={classNames('centerElement', styles.textWrapper)}>{accountType[profile?.accountType]}</div>
        </div>
        <Menu
          selectedKeys={[selectedKey]}
          openKeys={openKeys}
          onOpenChange={handleOpenChange}
          mode="inline"
          inlineCollapsed={collapsed}
          className={classNames('menuWrapperSideNav', styles.menuWrapperSideNav)}
          style={{ width: collapsed ? 80 : 215, transition: 'width 0.3s' }}
        >
          {routes?.map((route: any) => {
            if (route?.children) {
              return (
                <SubMenu key={route.key} icon={route.icon} title={route.text}>
                  {route?.children?.map((childRoute: any) => {
                    if (!childRoute?.visible) return;
                    if (
                      childRoute.key === KEY_SIDE_NAV.SHIPPING_SHIPPING_FROM_HOME &&
                      profile?.accountType === CustomerAccountType.BUSINESS &&
                      profile?.locationType === CustomerLocationType.DOMESTIC
                    ) {
                      return (
                        <Menu.Item key={childRoute.key} data-tut={childRoute?.keyTour}>
                          <Link to={childRoute.url}>{childRoute.text}</Link>
                        </Menu.Item>
                      );
                    }
                    if (childRoute.key !== KEY_SIDE_NAV.SHIPPING_SHIPPING_FROM_HOME) {
                      return (
                        <Menu.Item key={childRoute.key} data-tut={childRoute?.keyTour}>
                          <Link to={childRoute.url}>{childRoute.text}</Link>
                        </Menu.Item>
                      );
                    }
                  })}
                </SubMenu>
              );
            }
            return (
              <Menu.Item key={route.key} icon={route.icon} onClick={() => setIsOpenMenuMobile(false)}>
                <Link to={route.url}>{route.text}</Link>
              </Menu.Item>
            );
          })}
        </Menu>
      </Drawer>
      <TourMenu isTourOpen={isMobile ? false : isTourOpen} setIsTourOpen={setIsTourOpen} setOpenKeys={setOpenKeys} />
    </>
  );
}
